import { SuccessPlanState } from "components/summary/success-plan/state/successPlan.types";
import { FEATURE_KEY } from "constant";

export function getStepIndicator(features: FEATURE_KEY[]): SuccessPlanState["stepIndicator"] {
  if (features.includes(FEATURE_KEY.EDIT_EXPAND_PLAN_REVAMP)) {
    return "csmStepper";
  }
  if (features.includes(FEATURE_KEY.UPDATE_CONCIERGE)) {
    return "cseStepper";
  }
  if (features.includes(FEATURE_KEY.EDIT_PARTNER_SUCCESS)) {
    return "partnerStepper";
  }
  if (features.includes(FEATURE_KEY.EDIT_EPSM_PARTNER_SUCCESS)) {
    return "epsmPartnerStepper";
  }
  if (features.includes(FEATURE_KEY.EDIT_VIDCAST_SUCCESS)) {
    return "vidcastStepper";
  }

  return null;
}
